import {all, call, fork, put, select, takeLatest} from "redux-saga/effects";
import {
    GET_CHAMPIONS_BUILD_FAILURE,
    GET_CHAMPIONS_BUILD_REQUEST,
    GET_CHAMPIONS_BUILD_SUCCESS,
    GET_CHAMPIONS_BUILD_VERSION_FAILURE,
    GET_CHAMPIONS_BUILD_VERSION_REQUEST,
    GET_CHAMPIONS_BUILD_VERSION_SUCCESS,
    GET_CHAMPIONS_MASTERY_FAILURE,
    GET_CHAMPIONS_MASTERY_REQUEST,
    GET_CHAMPIONS_MASTERY_SUCCESS,
    GET_CHAMPIONS_PATCH_HISTORY_FAILURE,
    GET_CHAMPIONS_PATCH_HISTORY_REQUEST,
    GET_CHAMPIONS_PATCH_HISTORY_SUCCESS,
    GET_CHAMPIONS_RANK_FAILURE,
    GET_CHAMPIONS_RANK_REQUEST,
    GET_CHAMPIONS_RANK_SUCCESS,
    GET_CHAMPIONS_VERSIONS_REQUEST,
    GET_CHAMPIONS_VERSIONS_SUCCESS,
    GET_MASTERY_RANKING_FAILURE,
    GET_MASTERY_RANKING_REQUEST,
    GET_MASTERY_RANKING_SUCCESS
} from "../reducer/champions";
import {championCapitalize, currentLangToRegion, sortChampData} from "../../function";
import {secretApi} from "../../api/api";
import axios from "axios";

//+ == queryString에서 스페이스바로 인식됨.


const getRiotData = async ({language, version}) => {
    const riot_data_url = new URL(`${process.env.REACT_APP_CACHE_API}common/riot_data`)
    riot_data_url.searchParams.set('country_code', language);
    riot_data_url.searchParams.set('version', version);
    const result = await axios.get(riot_data_url.toString())
    const data = result.data
    return data;
}


const getRuneByVersion = async ({language, version}) => {
    const result = await axios.get(`${process.env.REACT_APP_RUNE}?version=${version}&lang=${language}`)
    const data = result.data
    return data;
}

const getSpellByVersion = async ({language, version}) => {
    const result = await axios.get(`${process.env.REACT_APP_SPELL}?version=${version}&lang=${language}`)
    const data = result.data.data
    return data;
}

const getItemByVersion = async ({language, version}) => {
    const result = await axios.get(`${process.env.REACT_APP_ITEM}?version=${version}&lang=${language}`)
    const data = result.data.data
    return data;
}

const getChampionSpell = (data) => {
    return axios.get(`${process.env.REACT_APP_IMG}${data.version}.1/data/${currentLangToRegion(data.currentLang)}/champion/${championCapitalize(data.championName)}.json`).then((res) => {
        if (typeof res?.data?.data === 'object') {
            const result = Object.values(res.data.data)[0];
            return {
                spells: result.spells,
                passive: result.passive,
                version: data.version,
            };
        }
    }).catch(() => {
    });
}
const getPatchHistroy = (data) => {
    if (typeof data === 'object') {
        const getLang = data.currentLang === 'KOR' ? 'kr' : 'en';
        const url = `${process.env.REACT_APP_CACHE_API}champion/history?champion_id=${data.champion_id}&language=${getLang}`;
        return secretApi.get(url).then((result) => result.data);
    }
}

const getRankData = (action) => {
    if (typeof action === 'object') {
        const url = `${process.env.REACT_APP_CACHE_API}champion/rank?platform_id=KR&tier=${encodeURIComponent(action.tier)}&game_version=${action.version}`;
        return secretApi.get(url).then((result) => result.data);
    }
    return []
}
const getMasteryGlobalData = (action) => {
    if (typeof action === 'object') {
        const url = new URL(`${process.env.REACT_APP_CACHE_API}champion/mastery_rank`);
        url.searchParams.set('platform_id', action.platform_id);
        url.searchParams.set('lane', 'All');
        url.searchParams.set('champion_id', '0');
        url.searchParams.set('cnt', '100');
        // const url = `${process.env.REACT_APP_CACHE_API}champion/main_2302?platform_id=KR&tier=${encodeURIComponent(action.tier)}&game_version=${action.version}`;
        return secretApi.get(url.toString()).then((result) => result.data.data_list);
    }
}

const getChampionMasteryData = (action) => {
    if (typeof action === 'object') {
        const url = new URL(`${process.env.REACT_APP_CACHE_API}champion/mastery_rank`);
        url.searchParams.set('platform_id', action.platform_id);
        url.searchParams.set('lane', action.lane);
        url.searchParams.set('champion_id', action.champion_id);
        url.searchParams.set('cnt', '100');
        // const url = `${process.env.REACT_APP_CACHE_API}champion/main_2302?platform_id=KR&tier=${encodeURIComponent(action.tier)}&game_version=${action.version}`;
        return secretApi.get(url.toString()).then((result) => result.data.data_list);
    }
}

const getBuildData = (data) => {
    const url = `${process.env.REACT_APP_CACHE_API}champion/build?platform_id=KR&champion_id=${data.champion_id}&game_version=${data.game_version}&tier=${encodeURIComponent(data.tier)}`;
    return secretApi.get(url).then((result) => {
        const data = result.data;
        const reduced = Object.entries(data.build_by_lane).reduce((sum, cur) => {
            sum.push({...cur[1], lane: cur[0]})
            return sum;
        }, []);
        return reduced
    });
    // return testApi;
}

const getBalanceData = (data) => {
    const url = `${process.env.REACT_APP_CACHE_API}champion/champion_balance?champion_id=${data.champion_id}`;
    return secretApi.get(url).then((result) => result.data);
}
const getARAMTip = (data) => {
    const url = `${process.env.REACT_APP_CACHE_API}champion/comment_aram?language=${data.language === 'ko_KR' ? 'kr' : 'en'}`;
    return secretApi.get(url).then((result) => result.data.comment_list);
}

const getVersions = () => {
    const url = `${process.env.REACT_APP_CACHE_API}champion/version?cnt=3`;
    return secretApi.get(url).then((result) => result.data.game_version_list);
}


export function* getStateVersion() {
    let version = yield select((state) => state.champions.championVersions);

    if (version.length === 0) {
        version = yield call(getVersions);
        yield put({
            type: GET_CHAMPIONS_VERSIONS_SUCCESS,
            data: {
                versions: version,
            }
        })
    }
    return version;
}


function* getChampionRank(action) {
    try {
        const version = yield getStateVersion();

        const currentVersion = action?.data?.version !== 'null' && action?.data?.version ? action?.data?.version : version[0];
        const currentTier = action?.data?.tier !== 'null' && action?.data?.tier ? action?.data?.tier : "Emerald+";


        const dataObj = {
            version: currentVersion,
            tier: currentTier,
        }

        const getData = yield call(getRankData, dataObj);

        yield put({
            type: GET_CHAMPIONS_RANK_SUCCESS,
            data: getData,
        })
    } catch (e) {
        console.log(e);
        yield put({
            type: GET_CHAMPIONS_RANK_FAILURE,
            error: e,
        })
    }
}


function* getChampionsBuild(action) {
    try {
        const version = yield getStateVersion();

        const currentVersion = action?.data?.version !== 'null' && action?.data?.version ? action?.data?.version : version[0];
        const currentTier = action?.data?.tier !== 'null' && action?.data?.tier ? action?.data?.tier : "Emerald+";


        const obj = {
            champion_id: action?.data?.champion_id,
            game_version: currentVersion,
            tier: currentTier,
        }
        const runeObj = {
            language: action.data.currentLang,
            version: currentVersion,
        }


        const [getData, balance, aramTip, riotData] = yield all([call(getBuildData, obj), call(getBalanceData, obj), call(getARAMTip, runeObj), call(getRiotData, runeObj)]);
        const item = riotData.item_json.data
        const rune = riotData.runes_json
        const spell = riotData.spell_json.data
        yield put({
            type: GET_CHAMPIONS_BUILD_SUCCESS,
            data: {
                build: {
                    build: [...getData],
                    champion_id: action.data.champion_id,
                },
                balance: balance,
                rune,
                item,
                currentVersion,
                aramTip,
                spell,
                requestKey: action.data.requestKey,
            },
        })

    } catch (e) {
        console.log(e)
        yield put({
            type: GET_CHAMPIONS_BUILD_FAILURE,
            error: e,
        })
    }
}

function* getChampionsVersions() {
    try {
        const version = yield select((state) => state.champions.championVersions);
        if (version.length === 0) {
            const getVersion = yield call(getVersions);
            yield put({
                type: GET_CHAMPIONS_VERSIONS_SUCCESS,
                data: {
                    versions: getVersion,
                }
            })
        } else {
            yield put({
                type: GET_CHAMPIONS_VERSIONS_SUCCESS,
                data: {
                    versions: version,
                }
            })
        }


    } catch (e) {

    }
}


function* getChampionsBuildVersion(action) {
    try {

        const getData = yield call(getBuildData, action.data);

        yield put({
            type: GET_CHAMPIONS_BUILD_VERSION_SUCCESS,
            data: {
                build: getData.position_build_list,
                champion_id: action.data.champion_id,
            },
        })

    } catch (e) {
        console.log(e)
        yield put({
            type: GET_CHAMPIONS_BUILD_VERSION_FAILURE,
            error: e,
        })
    }
}

function* getChampionsPatchHistory(action) {
    try {

        const getData = yield call(getPatchHistroy, action.data);
        const aramVersionList = getData?.aram_patch_history?.champion_patch_history_list.map((data) => data.version);
        const srVersionList = getData?.sr_patch_history?.champion_patch_history_list.map((data) => data.version);
        const versionList = [...aramVersionList, ...srVersionList];


        const versionData = yield all(versionList.map((version) => getChampionSpell({
            ...action.data,
            version: version,
        })));


        yield put({
            type: GET_CHAMPIONS_PATCH_HISTORY_SUCCESS,
            data: {
                patchHistory: {
                    aram_patch_history: getData.aram_patch_history,
                    sr_patch_history: getData.sr_patch_history,
                    version_spell: versionData,
                },
                champion_id: action.data.champion_id,
                requestKey: action.data.requestKey,
            },
        })

    } catch (e) {
        console.log(e)
        yield put({
            type: GET_CHAMPIONS_PATCH_HISTORY_FAILURE,
            error: e,
        })
    }
}


function* getMasteryRanking(action) {
    try {
        const platform_id = action?.data?.region;
        const getData = yield call(getMasteryGlobalData, {platform_id});
        if (!Array.isArray(getData)) {
            throw "getMasteryGlobal check data type";
        }
        yield put({
            type: GET_MASTERY_RANKING_SUCCESS,
            data: {
                ranking: sortChampData(getData, [{value: 'rank', sortType: true}]),
            }
        })
    } catch (e) {
        console.log(e);
        yield put({
            type: GET_MASTERY_RANKING_FAILURE,
            error: e,
        })
    }
}

function* getChampionMastery(action) {
    try {
        const platform_id = action?.data?.region || 'All';
        const champion_id = action?.data?.champion_id || 0;
        const lane = action?.data?.lane || 'All';
        const obj = {
            platform_id,
            champion_id,
            lane,
        }
        const getData = yield call(getChampionMasteryData, obj);

        if (!Array.isArray(getData)) {
            throw "getMasteryGlobal check data type";
        }

        yield put({
            type: GET_CHAMPIONS_MASTERY_SUCCESS,
            data: {
                ranking: sortChampData(getData, [{value: 'rank', sortType: true}]),
            }
        })
    } catch (e) {
        console.log(e);
        yield put({
            type: GET_CHAMPIONS_MASTERY_FAILURE,
            error: e,
        })
    }
}

function* watchGetChampionsRank() {
    yield takeLatest(GET_CHAMPIONS_RANK_REQUEST, getChampionRank)
}

function* watchGetChampionsBuild() {
    yield takeLatest(GET_CHAMPIONS_BUILD_REQUEST, getChampionsBuild)
}

function* watchGetChampionsBuildVersion() {
    yield takeLatest(GET_CHAMPIONS_BUILD_VERSION_REQUEST, getChampionsBuildVersion)
}

function* watchGetChampionsVersions() {
    yield takeLatest(GET_CHAMPIONS_VERSIONS_REQUEST, getChampionsVersions)
}

function* watchGetChampionsPatchHistory() {
    yield takeLatest(GET_CHAMPIONS_PATCH_HISTORY_REQUEST, getChampionsPatchHistory)
}

function* watchGetMasteryRanking() {
    yield takeLatest(GET_MASTERY_RANKING_REQUEST, getMasteryRanking);
}

function* watchGetChampionsMasteryRanking() {
    yield takeLatest(GET_CHAMPIONS_MASTERY_REQUEST, getChampionMastery)
}

export default function* championsSaga() {
    yield all([
        fork(watchGetChampionsRank),
        fork(watchGetChampionsBuild),
        fork(watchGetChampionsBuildVersion),
        fork(watchGetChampionsVersions),
        fork(watchGetChampionsPatchHistory),
        fork(watchGetMasteryRanking),
        fork(watchGetChampionsMasteryRanking)
    ])
}
